// extracted by mini-css-extract-plugin
export var shake = "_u-0";